import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import {Editor} from '../editor-components';
import Spinner from '../spinner/spinner';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import StageEditor from '../stage-editor/stage-editor';
import ScreenEmulator from '../screen-emulator/screen-emulator';

/** @class EntryEditor
  * A component for editing a virtual expo's entry
  */
export default class EntryEditor extends ReactFireComponent {
  /** @constructor
    * Creates a new instance of EntryEditor
    */
  constructor(props) {
    super(props);
    this.state = {}
    this.dataURL = props.match.url;
  }
  /** @method componentWillMount
    * Connects the component to firebase
    */
  componentWillMount() {
    this.bindAsObject(this.dataURL + '/stage', 'stage')
  }
  /** @method componentWillUnmount
    * Removes the component's connection to firebase
    */
  componentWillUnmount() {
    this.unbind('stage')
  }
  /** @method render
    * Renders the component.
    */
  render() {
    if(!this.state.stage) return <Spinner/>
    return (
      <Editor>
        <Tabs>
          <TabList>
            <Tab>Stage</Tab>
            <Tab>Preview</Tab>
          </TabList>
          <TabPanel>
            <StageEditor {...this.state.stage} dataURL={`${this.dataURL}/stage`} />
          </TabPanel>
          <TabPanel>
            <ScreenEmulator src={`/preview/#${this.dataURL}/stage`} />
          </TabPanel>
        </Tabs>
      </Editor>
    );
  }
}



// WEBPACK FOOTER //
// ./src/entry-editor/entry-editor.js